import styled from "styled-components";

export const Title = styled.h6`
	font-weight: bold;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	background: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 8px;
	width: 100%;
`;

export const AreaButtons = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 10px;
	gap: 1rem;
`;

export const BodyBox = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	transition: background 0.3s ease-out;
	width: 100%;

	&:hover {
		background: ${({ theme }) => theme.hoverGray};
	}
`;
